export default () => ['websale-dev', 'localhost'].some((path) => window.location.href.includes(path));
